import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form', 'query', 'display']

  connect() {}

  search(event) {
    const query = event.target.value
    if (query != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.formTarget.requestSubmit()
        this.saveSearchTerm(query)
      }, 750)
    } else {
      return (this.displayTarget.innerHTML = '')
    }
  }

  saveSearchTerm(query) {
    fetch('/user_search_terms', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
          .content,
      },
      body: JSON.stringify({ user_search_term: { term: query, kind: 0 } }),
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error('Error saving search term:', error)
      })
  }

  handleClick(event) {
    const linkName = event.target.textContent.trim()
    const formData = new FormData()
    formData.append('user_search_term[term]', linkName)
    formData.append('user_search_term[kind]', '1')

    fetch('/user_search_terms', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
          .content,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log("Clicked link saved:", data);
        window.location.href = event.target.href
      })
      .catch((error) => {
        console.error('Error saving clicked link:', error)
      })
  }


  remove() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      const frame = document.querySelector('turbo-frame[id="search_results"]')
      if (frame) {
        frame.innerHTML = ''
      }
    }, 350)
  }
}
